var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"page-header-title"},[_c('br'),_c('h4',{staticClass:"page-title"},[_vm._v("Principal")])]),_c('div',{staticClass:"page-content-wrapper"},[_c('div',{staticClass:"container-fluid"})])])
}]

export { render, staticRenderFns }